import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized, NavigationEnd } from '@angular/router';
import { WindowRef } from './providers/window-ref';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  navigating: boolean = true;
  constructor(private router: Router, private winRef: WindowRef) {
  }

  ngOnInit() {
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.navigating = true;
      }
      if (val instanceof NavigationEnd) {
        this.winRef.nativeWindow.scrollTo(0, 0);
        setTimeout(() => {
          this.navigating = false;
        }, 500);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts